import React from 'react';
import { motion } from 'framer-motion';
export function TacticalBackground() {
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden bg-tactical-dark" data-id="element-222">
      {/* Base Grid */}
      <div className="absolute inset-0 bg-grid-pattern opacity-50" data-id="element-223"></div>

      {/* Center Pitch Circle Motif */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] border border-tactical-cyan/10 rounded-full" data-id="element-224"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-tactical-cyan/5 rounded-full" data-id="element-225"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-tactical-cyan/30 rounded-full" data-id="element-226"></div>

      {/* Center Line Motif */}
      <div className="absolute top-0 bottom-0 left-1/2 w-px bg-tactical-cyan/10" data-id="element-227"></div>

      {/* Animated Scanning Radar Arc */}
      <motion.div className="absolute top-1/2 left-1/2 w-[800px] h-[800px] -translate-x-1/2 -translate-y-1/2 rounded-full border-t border-tactical-cyan/20" animate={{
      rotate: 360
    }} transition={{
      duration: 20,
      repeat: Infinity,
      ease: 'linear'
    }} style={{
      originX: 0.5,
      originY: 0.5
    }} data-id="element-228">
        <div className="absolute top-0 left-1/2 w-1/2 h-full bg-gradient-to-r from-transparent to-tactical-cyan/5 origin-left" style={{
        clipPath: 'polygon(0 50%, 100% 0, 100% 50%)'
      }} data-id="element-229"></div>
      </motion.div>

      {/* Top/Bottom Vignette to blend content */}
      <div className="absolute inset-0 bg-gradient-to-b from-tactical-dark via-transparent to-tactical-dark" data-id="element-230"></div>
    </div>;
}